

<div class="d-flex justify-content-start align-items-center mt-2">
<img class="filter-img-width mr-2 text-left" [src]="isChecked ? 'assets/templates/' + template.name + '/icone_color-min.webp' : 'assets/templates/' + template.name + '/icone_black.png'" />
  <div class="d-flex align-items-center"><p class="filter-text text-left" [ngStyle]="{'color': isChecked ? 'var(--' + template.name + ')' : 'gray'}">
    {{ template.name }}
  </p></div>
</div>